import api from "../../../service/api";
import { DEFAULT_PAGING_SIZE } from "../../../utilities/staticConfigs";

export const reportGeneratorListing =({practice_id,page,
    reference_id,
    report_type,
    status,
    from_date,
    to_date})=> {
    let path = `reports/report-generation/?practice_id=${practice_id}&page_size=${DEFAULT_PAGING_SIZE}&page=${page}`;
    
    if (reference_id) {
        path += `&reference_id=${reference_id}`
    } 
    if (report_type) {
        path += `&report_type=${report_type}`
    }
    if (status) {
        path += `&status=${status}`
    }
    if (from_date) {
        path += `&from_date=${from_date}`
    }
    if (to_date) {
        path += `&to_date=${to_date}`
    }
    return api.get(path);
}

export const reportTableGenerator = (query) => {
    let path = 'reports/generate-report/';
    return api.post(path,query)
}